import React from "react";
import PropTypes from "prop-types";

import styles from "./options.module.scss";

function Options({options}) {
  return (
    <div className={styles.root}>
      {options
        .filter(
          ({name}) =>
            name === `color` ||
            name === `size` ||
            name === `man_size` ||
            name === `woman_size`
        )
        .map(({name, content}) => (
          <div key={name} className={styles[`${name}Option`]}>
            {content.map(({label, value}) => (
              <span
                key={value}
                style={name === `color` ? {backgroundColor: label} : {}}
              >
                {name === `color` ? `` : label}
              </span>
            ))}
          </div>
        ))}
    </div>
  );
}

Options.propTypes = {
  options: PropTypes.array
};

export default Options;
